export const RecoverPasswordQaLabels = {
  emailInput: "email",
  submitButton: "submit-btn",
  backToLoginButton: "back-to-login-btn",
  emailSuccessMessage: "email-success-message"
};
